import React from 'react';
import PropTypes from 'prop-types';
import { get } from '../Storage';
import { DateTool } from 'mgToolsKit';
import { ProgressBar } from "../../../Common/ui";

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'WidgetCasinoPromotionComponent';

var styles = AppSettings.styles;

class CasinoPromotion extends React.Component {
    constructor(props) {
        super(props);
        this.openListGameHandler = this.openListGameHandler.bind(this);
    }

    openListGameHandler() {      
        location.href = AppSettings.casinopromourl;
    }
    
    renderProgressBar(){

        var promotion = this.props.data;
        var max = promotion.couponAmount * promotion.wagering;
        var _percent = promotion.currentWagering * 100 / max;        
        
        return (
            <ProgressBar percentage={parseInt(_percent)} />
        );
        
    }

    renderScadenza(){

        var promotion = this.props.data;
        
        var expire = promotion.endedOn;
        if(isNaN(expire) || expire <=0){
            return "";
        }        
        var date = new DateTool(expire);
        var expireString = "al " + date.getDate()
        if(date.isToday()){
            expireString = "a oggi";
        }
        if(date.isTomorrow()){
            expireString = "a domani";
        }
        return (
            <span className="mg-bonus-data">Valido fino <strong>{expireString}</strong></span>
        )        
        
    }

    render() {
        var promotion = this.props.data;
        var key = "promo_detail_" + promotion.id;        

        var isWagering = promotion.wagering > 0;

        var formatEuro = new Intl.NumberFormat('it-IT', {
            style: 'currency',
            currency: 'EUR',
        });
        var _amount = formatEuro.format(promotion.couponAmount);
              
        return ( 

            <div key={key} className="mg-user-widget mg-bonus-freerounds">                
                <div className="mg-dati-ecoupon" onClick={this.openListGameHandler}>
                <i className="mg-icon-freerounds"></i>
                <div className="mg-bonus-wrap">
                <a className="mg-play-game" href={AppSettings.casinopromourl}>
                    <span className="mg-user-widget-titolo">
                    {promotion.description} 
                    </span>
                </a>
                {(isWagering && promotion.isInWagering) ?                                       
                    <span className="mg-bonus-data">
                        {this.renderProgressBar()}
                    </span>
                : ""}                        
                    {this.renderScadenza()}                        
                </div>
                {(isWagering && promotion.isInWagering) ? 
                    <span className="mg-bonus-importo--valore">
                        {_amount}
                    </span>
                    :
                    <span className="mg-bonus-importo--valore">
                        {promotion.freeRounds}
                    </span>
                }
                </div>                
            </div>
        )
    }
}

CasinoPromotion.displayName = componentName;

// PropTypes validation
CasinoPromotion.propTypes = {
    data: PropTypes.object.isRequired
};

// default props
CasinoPromotion.defaultProps = {
};

CasinoPromotion.contextTypes = {
    handleSetPage: PropTypes.func,
    handlePlayCasinoGame: PropTypes.func
}
export default CasinoPromotion;